import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import { Body } from '~/components/typography/Content'
import { Heading3 } from '~/components/typography/Titles'
import { cn } from '~/lib/utils'

type NotesDisplayProps = {
  notes: string | null | undefined
  canEdit: boolean
  className?: string
  editButton?: React.ReactNode
}

export function NotesDisplay({ notes, canEdit, className, editButton }: NotesDisplayProps) {
  const { t } = useTranslations('notes')

  return (
    <View className={cn('mx-3 rounded-content-inner bg-tertiary-foreground/50 pt-4', className)}>
      <View className="flex-row items-center justify-between border-b border-tertiary/30 pb-3 pl-5 pr-3">
        <Heading3 className={cn(!canEdit && 'flex-1 text-center')}>
          {t(($) => $.display.title)}
        </Heading3>
        {canEdit && editButton}
      </View>

      <Body className={cn('px-5 py-4 text-primary', !notes && 'italic text-foreground/50')}>
        {notes || t(($) => $.display.empty)}
      </Body>
    </View>
  )
}
